<template>
  <v-form v-on:submit.stop.prevent>
    <!--ver para que el lazy validation xD -->
    <v-container grid-list-xl fluid>
      <v-layout>
        <v-flex xs12 md12>
          <v-card max-width="100%" height="115">
            <v-card-text>Nivel: {{ this.nivel }}</v-card-text>
            <v-card-text>Tipo De Prueba: {{ this.tipoPrueba }}</v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout justify-center>
        <v-flex xs12 md6>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Digite código curso"
            single-line
            hide-details
            @keyup.enter.stop.prevent="loadData()"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex md12>
          <v-layout>
            <v-flex lg12>
              <div v-if="loading">
                <loading></loading>
              </div>
              <v-spacer></v-spacer>
              <template>
                <v-data-table
                  :headers="headers"
                  :items="itemsScan"
                  :search="search"
                  :rows-per-page-items="rowsPerPageItems"
                  class="elevation-1"
                >
                  <template v-slot:items="props">
                    <td class="text-xs-left">{{ props.item.codigoCurso }}</td>
                    <td class="text-xs-left">
                      {{ props.item.codBarraContenedora }}
                    </td>
                    <td class="text-xs-left">{{ props.item.codBarraDia }}</td>
                    <td class="text-xs-left">{{ props.item.fechaScan }}</td>
                  </template>
                </v-data-table>
              </template>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs2 order-md4>
          <v-btn
            color="blue"
            class="v-pagination__item v-pagination__item--active btn-pg"
            >{{ page }} ... {{ totalPages }}</v-btn
          >
        </v-flex>
        <v-flex xs2 order-md4>
          <v-btn
            class="pagination-next btn-ic"
            v-on:click="changePage(page + 1)"
          >
            <i
              aria-hidden="true"
              class="v-icon fa fa fa fa-chevron-right theme--light ic"
            ></i>
          </v-btn>
        </v-flex>
        <v-flex xs2 order-md3>
          <v-btn
            class="pagination-previous btn-ic"
            v-on:click="changePage(page - 1)"
          >
            <i
              aria-hidden="true"
              class="v-icon fa fa fa fa-chevron-left theme--light ic"
            ></i>
          </v-btn>
        </v-flex>
      </v-layout>
      <v-card-actions class="pb-3">
        <v-spacer></v-spacer>
        <v-btn
          :loading="loading"
          v-if="botonDescarga == true"
          color="primary"
          @click="descargaMasiva()"
          >Descarga</v-btn
        >
        <v-spacer></v-spacer>
      </v-card-actions>
      <v-dialog v-model="dialogLoading" persistent max-width="390">
        <loading-descarga></loading-descarga>
      </v-dialog>
    </v-container>
  </v-form>
</template>

<script>
import { mapState, mapActions } from "vuex";
// import { validationMixin } from "vuelidate";
// import { required, maxLength, email } from "vuelidate/lib/validators";
import { misMixins } from "@/mixins/myMixing.js";
import axios from "axios";
// import { error } from "util";
import Loading from "@/views/ui/Loading.vue";
import AlertEmpty from "@/views/ui/AlertEmpty.vue";
import LoadingDescarga from "@/views/ui/LoadingDescarga.vue";
import DataAdjunto from "@/components/AdjuntoData.vue";

export default {
  name: "scan-data",
  components: {
    AlertEmpty,
    DataAdjunto,
    LoadingDescarga,
    Loading,
  },
  mixins: [misMixins],
  props: {
    tipeView: "",
    id: "",
  },
  data() {
    return {
      search: "",
      page: 1,
      pages: 1,
      rowsPerPageItems: [20],
      totalPages: 0,
      total: "",
      headers: [
        { text: "Curso", sortable: false, value: "codigoCurso" },
        { text: "Caja", sortable: false, value: "caja" },
        { text: "Cja Día", sortable: false, value: "cajaDia" },
        { text: "Fecha SCAN", sortable: false, value: "fecha" },
      ],
      itemsScan: [],
      select: { nombre: "Sin asignar" },
      btnHidden: true,
      dialogLoading: false,
      loading: false,
      dialogGrid: false,
      filter: false,
      botonDescarga: false,
      itemsDocs: [],
      contratoId: "",
      nivel: "",
      tipoPrueba: "",
      idVisitas: "",
      validacion: "",
      proceso: "",
      tab: "",
      tipeArchive: "",
      filenameValue: "",
      filename: "",
      base64Value: "",
      codigo: "",
      codCursoSelect: [],
      codCursoValue: "",
      visita: "",
    };
  },
  watch: {
    dialogLoading(val) {
      if (!val) return;

      setTimeout(() => (this.dialogLoading = false), 4000);
    },
  },

  created() {
    this.tab = this.$store.getters.subTabSelectedStored;
    this.user = this.$store.getters.userLogged.tipo;
    this.id = this.$route.params.id;
    this.tipoPrueba = this.$route.params.tipoPrueba;
    this.codigo = this.$route.params.codigo;
    this.nivel = this.$route.params.nivel;
    console.log(this.id);
    this.loadData();
    this.loadDataCodigo();
  },
  mounted() {
    this.contratoId = this.$store.getters.contratoStored;
    this.idUsuario = this.$store.getters.userLogged.id;
    this.proceso = this.$store.getters.subProTabSelectedStored;
  },
  computed: {},
  methods: {
    submit() {
      this.$v.$touch();
    },
    async loadScanFilter() {
      let idContrato = this.$store.getters.contratoStored;
      this.body = {
        nivel: this.nivel,
        tipoPrueba: this.tipoPrueba,
        codCurso: this.search,
        idContrato: idContrato,
        pageSize: 20,
        pageNumber: this.page,
      };
      return await axios
        .post("/captura/seguimiento/scan/detalle", this.body)
        .then(function (response) {
          return response.data;
          event.preventDefault();
          event.stopPropagation();
        })
        .catch((error) => {
          if (error) {
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
            this.loading = false;
          }
          return [];
        });
    },
    async loadData() {
      this.loading = true;

      var response = await this.loadScanFilter();
      this.itemsSc = response;
      this.itemsScan = response.matrizRptScanlst;

      if (this.itemsScan.length > 0) {
        this.pages = response.total;

        this.totalPages = Math.ceil(this.pages / 50);
        this.alerta = false;
        this.botonDescarga = true;
      } else {
        this.alerta = true;
        this.page = 1;
        this.totalPages = 0;
        this.pages = 1;
      }
      this.loading = false;
      event.preventDefault();
      event.stopPropagation();
    },
    changePage(page) {
      this.page = page <= 0 || page > this.pages ? this.page : page;
      this.loadData();
    },
    clear() {
      this.codCursoValue = "";
      this.loadData();
    },
    async loadDataCodigo() {
      this.itemsCodigoCurso = await this.loadCodigoCurso();
      if (this.itemsCodigoCurso.length > 0) {
        this.codCursoSelect = this.itemsCodigoCurso;
      }
    },
    async loadCodigoCurso() {
      let idContrato = this.$store.getters.contratoStored;
      return await axios
        .get("/seguimiento/scan/codigoCurso/" + idContrato)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          }
          return [];
        });
    },

    async descargaMasiva() {
      this.dialogLoading = true;
      let idContrato = this.$store.getters.contratoStored;
      let nivel = this.nivel;
      let filename = this.filenameValue;
      return await axios
        .get(
          "captura/seguimiento/scan/descargaMasiva/" +
            nivel +
            "/" +
            this.tipoPrueba +
            "/" +
            idContrato,
          { responseType: "blob" }
        )
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    back() {
      setTimeout(() => {
        this.$router.push({
          name: "ProcesoCaptura",
        });
      }, 1000);
    },
  },
};
</script>
